module.exports = "../study/imgs/maps/Nagano/S8/Climate/Temperture/Nagano_Temperture_HadGEM2_RCP26_End.png";